import React, { useEffect, useState } from 'react';
import { FiSmartphone, FiX } from 'react-icons/fi';

// ── "Install App" for the Super Admin PWA (see public/index.html). Chrome /
// Android / Edge: opens the browser's install prompt. iPhone (Safari has no
// prompt): shows the Share → "Add to Home Screen" steps. Hidden once the
// panel is already running as the installed app. ──
const isStandalone = () =>
  (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) || window.navigator.standalone === true;
const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent) ||
  (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

export default function InstallAppButton() {
  const [prompt, setPrompt] = useState(() => window.__saInstallPrompt || null);
  const [installed, setInstalled] = useState(isStandalone);
  const [help, setHelp] = useState(false);

  useEffect(() => {
    const ready = () => setPrompt(window.__saInstallPrompt || null);
    const done = () => { setInstalled(true); setPrompt(null); };
    window.addEventListener('sa-install-ready', ready);
    window.addEventListener('appinstalled', done);
    return () => {
      window.removeEventListener('sa-install-ready', ready);
      window.removeEventListener('appinstalled', done);
    };
  }, []);

  if (installed) return null;

  const onClick = async () => {
    if (prompt) {
      prompt.prompt();
      const choice = await prompt.userChoice.catch(() => null);
      window.__saInstallPrompt = null;
      setPrompt(null);
      if (choice && choice.outcome === 'accepted') setInstalled(true);
      return;
    }
    setHelp(true);
  };

  return (
    <>
      <button className="btn btn-primary btn-sm" onClick={onClick}
        style={{ display: 'flex', alignItems: 'center', gap: 6 }} title="Install Super Admin on this phone / computer">
        <FiSmartphone size={14} /> Install App
      </button>

      {help && (
        <div onClick={() => setHelp(false)}
          style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,.55)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
          <div onClick={e => e.stopPropagation()} className="card" style={{ maxWidth: 380, width: '100%' }}>
            <div className="card-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <strong>Install Super Admin</strong>
              <button className="btn btn-outline btn-icon btn-sm" onClick={() => setHelp(false)}><FiX size={14} /></button>
            </div>
            <div className="card-body" style={{ fontSize: 14, lineHeight: 1.7 }}>
              {isIOS() ? (
                <ol style={{ paddingLeft: 18, margin: 0 }}>
                  <li>Open this page in <b>Safari</b>.</li>
                  <li>Tap the <b>Share</b> button (square with ↑ arrow).</li>
                  <li>Choose <b>Add to Home Screen</b>, then <b>Add</b>.</li>
                </ol>
              ) : (
                <ol style={{ paddingLeft: 18, margin: 0 }}>
                  <li>Open this page in <b>Chrome</b>.</li>
                  <li>Tap the <b>⋮ menu</b> (top-right).</li>
                  <li>Choose <b>Install app</b> / <b>Add to Home screen</b>.</li>
                </ol>
              )}
              <div style={{ marginTop: 10, color: '#64748b', fontSize: 12 }}>
                The app opens straight into the Super Admin panel, full screen.
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
